import { NgModule } from '@angular/core';
import { SharedModule } from '~app/app/~shared/modules/shared.module';
import { AdvertiserListDatatableComponent } from './components/advertiser-datatable/advertiser-datatable.component';
import { AdvertiserDetailsComponent } from './components/advertiser-details/advertiser-details.component';

const DECLARATIONS = [
  AdvertiserListDatatableComponent,
  AdvertiserDetailsComponent
];

const MODULES = [SharedModule];

@NgModule({
  declarations: DECLARATIONS,
  // imports: [...MODULES, ...IMPORT_ONLY_MODULES],
  imports: [...MODULES],
  exports: [...MODULES, ...DECLARATIONS],
  providers: []
})
export class AdvertiserModule {}
